/**
 * @description 第三方授权登录
 */

/*************************************** Helper ************************************************/
import { GoogleSigninHelper } from "@modules/common/tool/google-sign-in/google-sign-in-helper";
import { FacebookSigninHelper } from "@modules/common/tool/facebook-sign-in/facebook-sign-in-helper";

/*************************************** Controller ************************************************/
import { SocialLoginController } from "./social-login.controller";
import { RestfulAccessorProvider } from "@core/data-access/restful";

/*************************************** Config ************************************************/
import { socialLoginRestServiceConfig } from "@modules/partner/rest/social-login/social-login-rest.config";

/*************************************** Service ************************************************/
import { SocialLoginRestService } from "@modules/partner/rest/social-login/social-login-rest.service";


/************************************** 内容注册 ***********************************************/
let module_name = "social-login";

angular.module("social-login", [])
    .controller({
        socialLoginController: SocialLoginController
    })
    .service({
        socialLoginRestService: SocialLoginRestService
    })
    .config(["$accessorProvider", function($accessor: RestfulAccessorProvider) {
        $accessor.config(socialLoginRestServiceConfig);
    }])

export { module_name };

// google第三方授权
GoogleSigninHelper.loadGoogleSigninScriptLabel();
// facebook第三方授权
// FacebookSigninHelper.loadFacebookSigninScriptLabel();
